import { useInView } from 'framer-motion';
import { useRef } from 'react';
import type { ButtonGroupProps } from 'react-multi-carousel';

import PopFinishesCarouselNavButton from './PopFinishesCarouselNavButton';
import type { PopFinishesCarouselSlideSwatch } from './types';

export interface PopFinishesCarouselNavProps extends ButtonGroupProps {
  readonly swatches: PopFinishesCarouselSlideSwatch[];
}

const PopFinishesCarouselNav = ({
  carouselState,
  goToSlide,
  swatches,
}: PopFinishesCarouselNavProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, { once: true });

  const handleChange = (index: number) => {
    goToSlide?.(index);
  };

  return (
    <div
      className="absolute bottom-10 left-1/2 max-w-[80%] -translate-x-1/2 rounded-[80px] bg-white p-1 md:bottom-12 lg:px-4 nojs:hidden"
      ref={ref}
    >
      <ul className="flex">
        {swatches.map((swatch, i) => (
          <li key={swatch.label}>
            <PopFinishesCarouselNavButton
              index={i}
              isActive={carouselState?.currentSlide === i}
              isInView={isInView}
              onChange={handleChange}
              {...swatch}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PopFinishesCarouselNav;
